import { render, staticRenderFns } from "./aedContactSelector.vue?vue&type=template&id=fb12864c&"
import script from "./aedContactSelector.vue?vue&type=script&lang=js&"
export * from "./aedContactSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports